export enum EnumPages {
    main = 'main',
    about = 'about',
    price = 'price',
    instructions = 'instructions',
    education = 'education',
    contacts = 'contacts',
    profile = 'profile',
    demo = 'demo',
    documents = 'documents',
    cookies = 'cookies',
}